import React, { useState } from "react";

import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  Button,
  Input,
  Select,
} from "@chakra-ui/react";

import cross_dark_icon from "../../assets/images/icons/cross_dark_icon.png";
import check_icon from "../../assets/images/icons/check_icon.png";

export default function SupplierFilterModal(props) {
  const { isOpen, onClose, setsetSearchTermProp, setSortByLastUpdatedProp } =
    props;

  const [sortByLastUpdated, setSortByLastUpdated] = useState("DSC");
  const [searchTerm, setSearchTerm] = useState("");

  const handleSubmit = async (event) => {
    event.preventDefault();

    setsetSearchTermProp(searchTerm);
    setSortByLastUpdatedProp(sortByLastUpdated);

    onClose();
    return;
  };

  const sort_last_updated_selector_data = [
    {
      value: "ASC",
      label: "Oldest First",
    },
    { value: "DSC", label: "Newest First" },
  ];

  return (
    <>
      <Modal isOpen={isOpen} onClose={onClose} isCentered size="xl">
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>
            <div className="flex flex-row gap-2">
              <div className="h-6 w-6  flex flex-col justify-center ">
                {/* <img src={support_dark_icon} /> */}
              </div>

              <h4>New Support Ticket</h4>
            </div>
            <ModalCloseButton />
          </ModalHeader>

          <form onSubmit={(e) => handleSubmit(e)}>
            <ModalBody sx={{ padding: "2rem" }}>
              <div className="flex flex-col gap-5">
                <div className="w-5/6">
                  <p className="label">Search</p>
                  <Input
                    type="text"
                    name="Search"
                    onChange={(e) => setSearchTerm(e.target.value)}
                    value={searchTerm}
                    sx={{ height: "1rem", padding: "1.5rem" }}
                  />
                </div>
                <div className="w-5/6">
                  <p className="label">Sort By</p>
                  <div className=" w-full flex flex-col justify-center mr-2  ">
                    <Select
                      size="lg"
                      onChange={(e) => setSortByLastUpdated(e.target.value)}
                      value={sortByLastUpdated}
                      sx={{ borderColor: "black" }}
                    >
                      {sort_last_updated_selector_data.map((data, index) => {
                        return (
                          <option key={index} value={data.value}>
                            {data.label}
                          </option>
                        );
                      })}
                    </Select>
                  </div>
                </div>
              </div>
            </ModalBody>

            <ModalFooter>
              <div className="flex flex-row justify-end gap-2">
                <div className="h-[3.13]">
                  <Button
                    sx={{ height: "3.13rem" }}
                    variant="ghost"
                    onClick={onClose}
                  >
                    <img alt="cancel" className="mr-2" src={cross_dark_icon} />
                    Cancel
                  </Button>
                </div>

                <div className="w-[10rem] h-[3.13]">
                  <Button type="submit" onClick={handleSubmit}>
                    <img alt="Apply" className="mr-2" src={check_icon} />
                    Apply
                  </Button>
                </div>
              </div>
            </ModalFooter>
          </form>
        </ModalContent>
      </Modal>
    </>
  );
}
